import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type ECommerceOrdersRequest } from '../types/apiRequest'
import { type ECommerceOrdersResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const {
  useRequest,
  mutateAll,
} = createRequestHelper<ECommerceApis['get']['eCommerceOrders'], ECommerceOrdersResponse, ECommerceOrdersRequest>({
  client: 'eCommerce',
  key: (params) => {
    const { project_code, site_id, status, type, ...restParams } = params || {}
    if (!project_code || !site_id || !status || !type) return null
    return `/orders?${queryStringify({ project_code, site_id, status, type, ...restParams }, {
      skipNull: true,
    })}`
  },
  isImmutable: true,
  mutateAllMatcher: key => key.startsWith('/orders'),
})

export const useApiECommerceOrders = useRequest
export const mutateAllECommerceOrders = mutateAll
